import { useEffect, useState } from 'react'
import { Drawer } from '@design-systems/canvas-ui'
import RFIComments from './RFIComments'
import RFIAuditTrail from '../RFIAuditTrail'
import { TARGET } from '../../../common/commonConstants'
import { getRFIApprovalComments } from '../../../services/lcmService'

/**
 * Component to show RFI Audit Trail drawer + Comments drawer
 * @param {*} props
 * @returns
 */
const RFIAuditCommentsDrawer = (props) => {
  const [commentsCount, setCommentsCount] = useState(0)

  useEffect(() => {
    if (!props.supplierId) return

    const loadCommentsCount = async () => {
      try {
        const response = await getRFIApprovalComments(
          props.rfiType,
          props.supplierId,
          props.locationId,
          props.view,
          props.manufacturingTypeId,
        )
        const comments = response?.data || {}
        setCommentsCount(
          Array.isArray(comments)
            ? comments.length
            : Object.values(comments).reduce(
                (count, commentList) =>
                  count + (Array.isArray(commentList) ? commentList.length : 0),
                0,
              ),
        )
      } catch {
        setCommentsCount(0)
      }
    }

    loadCommentsCount()
  }, [
    props.rfiType,
    props.supplierId,
    props.locationId,
    props.view,
    props.manufacturingTypeId,
  ])

  return (
    <>
      {/* 1. Audit Trail */}
      <Drawer
        isOpen={props.isAuditTrailDrawerOpen}
        onRequestClose={() => props.closeAuditTrailDrawer()}
        headingText={
          <span className="lcm-rfi-drawer__heading">Audit Trail</span>
        }
        size={{ xs: 3 }}
        className="lcm-rfi-audit-comments-drawer"
      >
        <RFIAuditTrail
          isReadonly={props.view === TARGET}
          rfiType={props.rfiType}
          supplierId={props.supplierId}
          manufacturingTypeId={props.manufacturingTypeId}
          vettingStatus={props.vettingStatus}
          locationId={props.locationId}
          refreshRFIScreen={props.refreshRFIScreen}
          getLastRFI3Activity={props.getLastRFI3Activity}
        />
      </Drawer>

      {/* 2. Chat */}
      <Drawer
        isOpen={props.isCommentsDrawerOpen}
        onRequestClose={() => props.closeCommentsDrawer()}
        headingText={
          <span className="lcm-rfi-drawer__heading">
            Comments ({commentsCount})
          </span>
        }
        size={{ xs: 3 }}
        className="lcm-rfi-audit-comments-drawer"
      >
        <RFIComments
          rfiType={props.rfiType}
          supplierId={props.supplierId}
          supplierName={props.supplierName}
          setRFICommentsLen={(count) => setCommentsCount(count)}
          locationId={props.locationId}
          locationName={props.locationName}
          manufacturingType={props.manufacturingType} //NOTE: BE comments api still needs this, TODO: remove when API decom it
          manufacturingTypeId={props.manufacturingTypeId}
          view={props.view}
          focusCommentTab={props.focusCommentTab}
        />
      </Drawer>
    </>
  )
}

export default RFIAuditCommentsDrawer
